import * as styles from "./SectionWithList.module.scss";

import React from "react";
import { Button } from "../../../components/common";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface SectionWithListProps {
	heading: string;
	introText?: string;
	linkUrl?: string;
	linkTitle?: string;
	sectionExtraInfo?: string[];
	jumpLinksTitle?: string;
}

export const getSectionWithListProps = ({
	field_front_end_title,
	field_section_short_description,
	field_link,
	field_jump_links_title,
	relationships: { field_extra_section_info },
}: Queries.SectionDataFragment): SectionWithListProps => ({
	heading: field_front_end_title,
	introText: field_section_short_description?.value,
	linkUrl: field_link?.uri,
	linkTitle: field_link?.title,
	sectionExtraInfo: field_extra_section_info
		.map((extraInfo) => extraInfo?.field_extra_information?.value)
		.filter((extraInfo) => !!extraInfo),
	jumpLinksTitle: field_jump_links_title,
});
export const SectionWithList: React.FC<SectionWithListProps> = ({
	heading,
	introText,
	linkUrl,
	linkTitle,
	sectionExtraInfo,
	jumpLinksTitle,
}) => {
	return (
		<WrappedSection sectionName="SectionWithList">
			<div className={styles.sectionwithlist}>
				{jumpLinksTitle ? (
					<h2 className={styles.title} data-jumplinkstitle={jumpLinksTitle}>
						{heading}
					</h2>
				) : (
					<h2 className={styles.title}>{heading}</h2>
				)}
				<div className={styles.contentcontainer}>
					<div className={styles.sectioncontainer}>
						<div
							// biome-ignore lint/security/noDangerouslySetInnerHtml: Legit source
							dangerouslySetInnerHTML={{
								__html: introText || "",
							}}
						/>
						<Button url={linkUrl} variant="tertiary" size="small">
							{linkTitle}
						</Button>
					</div>
					<div className={styles.sectioncontainer}>
						<div
							className={styles.list}
							// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
							dangerouslySetInnerHTML={{
								__html: sectionExtraInfo,
							}}
						/>
					</div>
				</div>
			</div>
		</WrappedSection>
	);
};

export default SectionWithList;
